// extracted by mini-css-extract-plugin
module.exports = {"badgeContainer":"Badge_badgeContainer__3UGWY","badge":"Badge_badge__2245A"};